<template>
    <modal id="department-modal"
           v-model="showModal"
           :title="generateModalTitle('department')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.DEPARTMENTS'
              method="POST"
              ref="form">

            <app-form-group
                :label="$t('name')"
                type="text"
                v-model="formData.name"
                :placeholder="$placeholder('name')"
                :required="true"
                :error-message="$errorMessage(errors, 'name')"
            />

            <app-form-group-selectable
                type="search-select"
                :label="$t('manager')"
                list-value-field="employee_name"
                :chooseLabel="$t('manager')"
                v-model="formData.manager_id"
                :required="true"
                :error-message="$errorMessage(errors, 'manager_id')"
                :fetch-url="`${apiUrl.TENANT_SELECTABLE_DEPARTMENT_USERS}?without=admin&employee=only&with_auth=yes`"
            />

            <app-form-group-selectable
                type="select"
                v-if="parentDeptEditPermission"
                :label="$t('parent_department')"
                list-value-field="name"
                v-model="formData.department_id"
                :chooseLabel="$t('parent_department')"
                :fetch-url="apiUrl.TENANT_SELECTABLE_DEPARTMENT_DEPARTMENTS"
                :error-message="$errorMessage(errors, 'department_id')"
            />

            <div class="form-group">
                <label v-text="$t('location')"/>
                <div class="input-group dropdown" :class="{'show' : isOpen}">
                    <input
                        type="text"
                        class="form-control"
                        v-model="formData.location"
                        :placeholder="$placeholder('location')"
                        style="border-radius: 5px 0 0 5px !important;"
                        @keydown.enter.prevent="searchLocation"
                        @focus="isOpen = true"
                        @blur="handleBlur"
                    >
                    <div class="input-group-append">
                        <button :disabled="searchActive" class="btn btn-primary rounded-right" type="button"
                                @click="searchLocation">
                            <span class="w-100">
                                <loader v-if="searchActive" :loader-color="'white-color'"/>
                                <template v-if="!searchActive">
                                    {{ $t('search') }}
                                </template>
                            </span>
                        </button>
                    </div>
                    <div class="dropdown-menu" :class="{'show' : isOpen && locations.length > 0}">
                        <a
                            v-for="location in locations"
                            class="dropdown-item"
                            href="#"
                            v-text="location.address"
                            @click.prevent="selectLocation(location)"
                        />
                    </div>
                </div>
            </div>

            <app-form-group-selectable
                type="search-select"
                :label="$t('work_shift')"
                list-value-field="name"
                :chooseLabel="$t('work_shift')"
                v-model="formData.working_shift_id"
                :required="true"
                :error-message="$errorMessage(errors, 'working_shift_id')"
                :fetch-url="`${TENANT_SELECTABLE_WORK_SHIFT}`"
            />
            <upcoming-working-shift-view
                v-if="this.formData.upcoming_working_shift.length"
                :working-shifts="this.formData.upcoming_working_shift"
                @workingShiftRemoved="getEditData(selectedUrl)"
            />

            <app-form-group
                :label="$t('description')"
                type="textarea"
                v-model="formData.description"
                :placeholder="$textAreaPlaceHolder('description')"
            />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_SELECTABLE_WORK_SHIFT} from "../../../../../common/Config/apiUrl";
import UpcomingWorkingShiftView from "./UpcomingWorkingShiftView";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import loader from "../../../../../core/components/preloders/Loader.vue";

export default {
    name      : "DepartmentCreateEdit",
    components: {loader, UpcomingWorkingShiftView},
    mixins    : [FormHelperMixins, ModalMixin],
    comments  : {UpcomingWorkingShiftView},
    data() {
        return {
            TENANT_SELECTABLE_WORK_SHIFT,
            searchActive: false,
            isOpen      : false,
            locations   : [],
            formData    : {
                name                  : '',
                manager_id            : '',
                department_id         : '',
                location              : '',
                latitude              : '',
                longitude             : '',
                upcoming_working_shift: []
            },
        }
    },
    computed: {
        parentDeptEditPermission() {
            return this.selectedUrl ? this.formData.department_id : true;
        }
    },
    methods : {
        handleBlur() {
            this.blurTimeout = setTimeout(() => {
                this.isOpen = false;
            }, 200);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#department-modal').modal('hide');
            this.toastAndReload(data.message, 'department-table')
            this.$emit('input', false);
        },
        afterSuccessFromGetEditData({data}) {
            this.preloader = false
            this.formData  = data
            if (this.formData.department_id === null) {
                this.formData.department_id = ''
            }
            if (this.formData.manager_id === null) {
                this.formData.manager_id = ''
            }
            this.formData.working_shift_id = data.working_shift?.id
        },
        searchLocation() {
            const url         = `${TENANT_BASE_URL}api/google-autocomplete?input=${this.formData.location}`
            this.searchActive = true
            axiosGet(url).then(({data}) => {
                this.locations = data
                this.isOpen    = true
            }).finally(() => {
                this.searchActive = false
            })
        },
        selectLocation(location) {
            this.isOpen             = false
            this.formData.location  = location.address
            this.formData.latitude  = location.lat
            this.formData.longitude = location.lng
        }
    }
}
</script>
